exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-03a9e4df],.container .bg-img[data-v-03a9e4df],.container .bg-img img[data-v-03a9e4df]{width:100%\n}", "", {"version":3,"sources":["E:/chat/gaishi/src/components/guanzhu/guanzhu.vue"],"names":[],"mappings":";AACA,wGAAwG,UAAU;CACjH","file":"guanzhu.vue","sourcesContent":["\n.container[data-v-03a9e4df],.container .bg-img[data-v-03a9e4df],.container .bg-img img[data-v-03a9e4df]{width:100%\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03a9e4df","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/guanzhu/guanzhu.vue
// module id = MMyZ
// module chunks = 1